import React, { useState, useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"
import { Row, Col } from "react-bootstrap"

import { PENDING, IDLE } from "const"
import {
    MarkovGroup,
    MarkovGroupCreate,
} from "server/models"
import {
    useInput,
    StateType,
} from "client/utils"
import {
    StoreType,
    MarkovGroupValidation,
    SaveMarkovGroup,
    closeModal,
    setMarkovGroupEdit,
    setMarkovGroupReloadList,
    setMarkovGroupReloadEdit,
} from "client/store"
import {
    PageForm,
    FormGroup,
    Label,
    Input,
    Textarea,
    Feedback,
    Button,
    SpinnerIcon,
} from "client/components"

interface EditGroupProps {
    group: MarkovGroup
}

let isMounted: boolean

const Form = ({
    group,
}: EditGroupProps) => {
    const model = useSelector((state: StoreType) => state.markovModel.modelView)

    const modals = useSelector((state: StoreType) => state.system.modals)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [name, setName] = useInput(group.name)
    const [description, setDescription] = useInput(group.description)
    const [order, setOrder] = useState(group.order)

    const [validation, setValidation] = useState<MarkovGroupValidation>(null)

    const [saveState, setSaveState] = useState<StateType>(IDLE)
    const [applyState, setApplyState] = useState<StateType>(IDLE)

    useEffect(() => {
        isMounted = true
        return () => {
            isMounted = false
        }
    }, [])

    const onClose = () => {
        if (isMounted && modals.length) dispatch(closeModal())
    }

    const onSave = (mode: number) => {
        if (mode === 1) setSaveState(PENDING)
        if (mode === 2) setApplyState(PENDING)

        const newGroupData: MarkovGroupCreate = {
            modelId: group.modelId || model.id,
            name,
            description,
            order,
        }

        SaveMarkovGroup(
            group.id,
            newGroupData,
            lang,
        ).then((res) => {
            if (isMounted) {
                setValidation(res.validation)
                setSaveState(IDLE)
                setApplyState(IDLE)
            }
            if (res.validation) return

            dispatch(setMarkovGroupEdit({
                id: res.newGroupId || group.id,
                ...newGroupData,
            }))

            dispatch(setMarkovGroupReloadList(false))
            setTimeout(() => {
                dispatch(setMarkovGroupReloadList(true))
            }, 0)

            if (mode === 1) onClose()
            if (mode === 2) {
                dispatch(setMarkovGroupReloadEdit(false))
                setTimeout(() => {
                    dispatch(setMarkovGroupReloadEdit(true))
                }, 0)
            }
        })
    }

    return (
        <PageForm>
            <Row>
                <Col xs={12}>
                    <FormGroup>
                        <Label>{lang.name}</Label>
                        <Input type="text" value={name} onChange={setName} />
                        <Feedback>{validation && validation.name}</Feedback>
                    </FormGroup>
                    <FormGroup>
                        <Label>{lang.description}</Label>
                        <Textarea value={description} onChange={setDescription} />
                        <Feedback>{validation && validation.description}</Feedback>
                    </FormGroup>
                    <FormGroup>
                        <Label>{lang.order}</Label>
                        <Input
                            type="text"
                            value={order !== null ? order : ""}
                            onChange={(e) => {
                                const parsed = parseInt(e.target.value, 10)
                                if (!Number.isNaN(parsed)) setOrder(parsed)
                                else setOrder(null)
                            }}
                        />
                        <Feedback>{validation && validation.order}</Feedback>
                    </FormGroup>
                </Col>

                <Col xs={12}>
                    <Button variant="success" row onClick={() => onSave(1)}>
                        {saveState === PENDING ? <SpinnerIcon /> : lang.save}
                    </Button>
                    <Button variant="success" row onClick={() => onSave(2)}>
                        {applyState === PENDING ? <SpinnerIcon /> : lang.apply}
                    </Button>
                    <Button row onClick={onClose}>{lang.cancel}</Button>
                </Col>
            </Row>
        </PageForm>
    )
}
export default Form
